/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

export const getCenterAndZoom = (points) => {
  let span = 0.0001;
  let center = points[0];
  points.forEach((x) => {
    if (center.lat !== x.lat || center.lng !== x.lng) {
      center = new BMap.Point(
        (center.lng + x.lng) / 2,
        (center.lat + x.lat) / 2,
      );
    }
    points.forEach((y) => {
      span = Math.max(span, Math.max(
        Math.abs(x.lat - y.lat),
        Math.abs(x.lng - y.lng),
      ));
    });
  });
  let zoom = 2;
  if (span < 0.001) {
    zoom = 16;
  } else if (span < 0.1) {
    zoom = 14;
  } else if (span < 0.5) {
    zoom = 11;
  } else if (span < 1) {
    zoom = 8;
  } else if (span < 10) {
    zoom = 6;
  } else if (span < 20) {
    zoom = 5;
  }
  return [center, zoom];
};

export const transform = (devices = []) => {
  return devices
    .filter((gw) => {
      const { lat = '', lng = '' } = gw;
      return lat !== '' && lng !== '';
    })
    .map(gw => ({
      ...gw,
      point: new BMap.Point(gw.lng, gw.lat),
    }));
};

export const drawOval = (centre, x, y) => {
  const assemble = [];
  let angle;
  let dot;
  const tangent = x / y;
  for (let i = 0; i < 36; i += 1) {
    angle = ((2 * Math.PI) / 36) * i;
    dot = new BMap.Point(centre.lng + (Math.sin(angle) * y * tangent),
      centre.lat + (Math.cos(angle) * y));
    assemble.push(dot);
  }
  return assemble;
};

export const calLng = (km, lat) => {
  // const lng = (Math.cos(lat) * km) / 111;
  const lng = km / 100;
  if (typeof lng === 'number' && Math.abs(lng) >= 0.001) {
    return Math.abs(lng);
  }
  return 0.001;
};

export const calLat = (km) => {
  const lat = km / 111.32;
  if (typeof lat === 'number' && Math.abs(lat) >= 0.001) {
    return Math.abs(lat);
  }
  return 0.001;
};

export default {
  getCenterAndZoom,
  transform,
  drawOval,
  calLng,
};




// WEBPACK FOOTER //
// ./src/utils/map.js